import PropTypes from 'prop-types';
import I18n from 'I18n';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PasswordRuleValidation = ({
  rule,
  valid
}) => {
  const iconBackgroundColor = valid ? 'fill-positive-default' : 'fill-tertiary-pressed';
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(IconCircle, {
      icon: SuccessIcon,
      backgroundColor: iconBackgroundColor,
      color: "fill-tertiary-default",
      size: "100",
      padding: "100",
      margin: "200"
    }), I18n.text(`userPreferences.passwordRules.${rule}`)]
  }, rule);
};
PasswordRuleValidation.propTypes = {
  rule: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired
};
export default PasswordRuleValidation;